import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InputMask from 'react-input-mask';

import DatePicker from 'react-bootstrap-date-picker';
import TeamTasksAcoes from './TeamTasksAcoes';

class TeamTasksTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      date: '',
      team_id: null,
      name: '',
      dados: [],
    };
    this.refreshTable = this.refreshTable.bind(this);
    this.adicionarTarefa = this.adicionarTarefa.bind(this);
    this.botaoAcoes = this.botaoAcoes.bind(this);
    this.trocarStatus = this.trocarStatus.bind(this);
    this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeDatePicker(value, formattedValue) {
    this.setState({
      date: value,
      date_str: formattedValue,
    });
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.tarefas) && this.state.loaded === 0) {
      this.setState({dados: newProps.tarefas});
      this.setState({loaded: 1});
    }
  }

  refreshTable(event) {
    var url = config.get('api') + '/turma/buscar_tarefas/'+this.props.team_id;
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
        self.props.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  //Funcao para trocar na tabela
  trocarStatus(team_task) {
    var dados_temp = this.state.dados;
    dados_temp.map(function(dado, index){
      if (dado.id == team_task.id) {
        dados_temp[index].status = team_task.status;
      }
    });
    this.setState({dados: dados_temp});
  }

  botaoAcoes (cell, row) {
    var dados = this.state.dados;
    var tarefa = "";
    var date = "";
    var status = "";
    dados.map(function(dado, index){
      if (dado.id == cell) {
        tarefa = dado.tarefa;
        date = dado.date;
        status = dado.status;
      }
    });

    return (
      <TeamTasksAcoes editar={this.editar} handleAlert={this.props.handleAlert} refreshTable={this.refreshTable} tarefas={this.tarefas} tarefa={tarefa} trocarStatus={this.trocarStatus} team_task_id={cell} date={date} status={status} />
    );
  }

  adicionarTarefa(event) {
    event.preventDefault();
    var dados_salvar = {
      team_id: this.props.team_id,
      date: this.state.date_str,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/tarefa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarTarefa}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
            <label>Nome:</label>
            <input type="text" name="name" className="form-control" placeholder="Seu nome" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Data prevista:</label>
          <DatePicker onChange={this.handleChangeDatePicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data prevista" value={this.state.date} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar tarefa</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há tarefas cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="tarefa" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tarefa</TableHeaderColumn>
    <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data prevista</TableHeaderColumn>
    <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoAcoes} width='200'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default TeamTasksTab;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTasksTab.js